import { TabStyles, TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { DomainValidationStatus } from '../../types/DomainValidationStatus';
import { getErrorMessageForDomainValidationStatus } from '../../utils/DomainUtilities';

export type AddNewDomainTextFieldProps = Readonly<{
  onDomainNameChange: (domainName: string) => void;
  domainName: string;
  domainValidationStatus: DomainValidationStatus;
}>;

export function AddNewDomainTextField(props: AddNewDomainTextFieldProps) {
  const isValid = props.domainValidationStatus === DomainValidationStatus.NO_ERROR ? undefined : false;
  const errorMessage = getErrorMessageForDomainValidationStatus(props.domainValidationStatus);
  return (
    <TextFieldWidget
      label={Messages.bridgeSiteSettingsDomain()}
      onChange={e => props.onDomainNameChange(e.target.value)}
      onClear={() => props.onDomainNameChange('')}
      placeholder={''}
      testId={'domain-text-widget'}
      value={props.domainName}
      kind={'outline'}
      className={textFieldClass}
      style={{ width: '100%' }}
      valid={isValid}
      message={errorMessage}
    />
  );
}

const textFieldClass = cssClass('add-new-domain-text-field', 'root', {
  width: '100%',
  marginTop: TabStyles.Spacing.ExtraLargeSpace,
  marginBottom: TabStyles.Spacing.LargeSpace,
});
